<template>
  <div>
    <!-- Content Header (Page header) -->
   
    <!-- Main content -->
    <section class="content">
      <div class="box info-box">
        <div class="box-header with-border">
          Search By
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-md-3">
              <label for="Branch">Branch</label>
              <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchRecord(branch)"></v-select>
              
              <has-error
                :form="form"
                field="branch_id"
              ></has-error>
            </div>
            
          </div>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('loan-disbursement-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Individual Loan List</h3>
          
          <div class="box-tools">
            <button type="button" class="btn btn-success btn-sm" @click="newModalLoan" v-if="canAccess('loan-disbursement-create-loan')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr.</th>
                <th class="hidden-xs">Pl Name</th>
                <th class="hidden-xs">Pl Emi Type</th>
                <th>Loan Amt</th>
                <th>Member</th>
                <th class="hidden-xs">Staff</th>
                <th class="hidden-xs">Branch Name</th>
                <th class="hidden-xs">Branch code</th>
                <th class="hidden-xs">Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td class="hidden-xs">{{ planName(row.plan) }}</td>
                <td class="hidden-xs">{{ planRecoveryType(row.plan) }}</td>
                <!-- <td>
                  <b v-if="row.loanAmount">{{row.loanAmount}}</b>
                  <b v-else>{{ planAmt(row.plan) }}</b>
                </td> -->
                <td>{{ planAmt(row) }}</td>
                <td><button v-if="row.member"
                    @click="viewMemberAddDetail(row.member_id)"
                    class="btn btn-xs btn-info" >
                    {{row.member.name}}
                    </button>
                </td>
                <td class="hidden-xs"><span v-if="row.agent">{{ row.agent.name }}</span></td>
                <td class="hidden-xs">{{ row.branch.name }}</td>
                <td class="hidden-xs">{{ row.branch.branchCode }}</td>
                <td class="hidden-xs">{{ row.created_at | myDate }}</td>

                <td>
                  <div class="btn-group dropup">
                    <button type="button" class="btn btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                      Task <span class="caret"></span>
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" role="menu">
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a @click="viewPreviousLoanRecords(row)" title="Previous Loan">
                          <i class="fa fa-leanpub"></i> Previous Loan
                        </a>
                      </li>
                      <li v-show="row.filechargeStatus == 'exclude'">
                        <a @click="fileChargeModal(row)" title="File Charge">
                          <i class="fa fa-file"></i> File Charge
                        </a>
                      </li>
                      <li v-show="row.processingFeeStatus == 'exclude'">
                        <a @click="processingFeeModal(row)" title="Processing Fee">
                          <i class="fa fa-hourglass"></i> Processing Fee
                        </a>
                      </li>
                      <li v-show="row.insuranceFeeStatus == 'exclude'">
                        <a @click="insuranceFeeModal(row)" title="Insurance Fee">
                          <i class="fa fa-user-md"></i> Insurance Fee
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-create')">
                        <a v-show="row.status == 'pending'" @click="disbursmentModal(row)" title="Loan Disbursed">
                          <i class="fa fa-money"></i> Loan Disbursement
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a @click="viewPrintModal(row)" title="Loan Agreement">
                          <i class="fa fa-print"></i> Loan Agreement
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a @click="viewPrintDimandProbeshnoryNote(row)" title="Demand Promissory Note">
                          <i class="fa fa-sticky-note-o"></i> Demand Promissory Note
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-view')">
                        <a @click="viewPrintAadharAgreementLetter(row)" title="Aadhar Agreement Letter">
                          <i class="fa fa-handshake-o"></i> Aadhar Agreement Letter
                        </a>
                      </li>
                      <li v-if="canAccess('loan-disbursement-delete')">
                        <a @click="deleteDisbursment(row.id)" title="Delete Loan">
                          <i class="fa fa-trash"></i> Delete Loan
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->
      <div class="modal fade" id="newModalLoan">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Create New Loan</h4>
              <h4 v-show="editMode" class="modal-title">Update Loan</h4>
            </div>
            <form @submit.prevent="editMode ? updateLoan() : createLoan()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Branch <span class="red">*</span></label>
                            <select
                              v-model="form.branch_id"
                              name="branch_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_id'),
                              }"
                              @change="getMemberAndGroupAndAgent"
                              required
                            >
                              <option v-if="!form.branch_id" selected value="">
                                Select Branch
                              </option>
                              <option
                                :value="bra.id"
                                v-for="bra in branches"
                                :key="bra.id"
                              >
                                {{ bra.name }}
                              </option>
                            </select>
                            <has-error
                              :form="form"
                              field="branch_id"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label>Staff ID <span class="red">*</span></label>
                            <v-select v-model="staf" name="agent_id" label="name" :options="staffs" placeholder="Select Staff" v-on:input="getBranchAgent">

                            </v-select>
                            <has-error
                              :form="form"
                              field="agent_id"
                            ></has-error>
                          </div>
                          
                          <div class="form-group" v-if="form.planType == 'individual'">
                            <label>Member <span class="red">*</span></label>
                            <v-select v-model="mem"  name="member_id" label="name" :options="members" placeholder="Select Member" v-on:input="getBranchMember">
                              
                            </v-select>
                            
                            <has-error
                              :form="form"
                              field="member_id"
                            ></has-error>
                          </div>
                          <!-- text input -->
                          <div class="form-group">
                            <label>Purpose <span class="red">*</span></label>
                            <v-select v-model="form.purpose" name="purpose" label="name" placeholder="Select purpose" :options="purposes" v-on:input="getSelectPurpose"></v-select>
                            <has-error :form="form" field="purpose_id"></has-error>
                            <input
                              type="hidden"
                              name="purpose_id"
                              v-model="form.purpose_id"
                            />
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Plan <span class="red">*</span></label>
                            <v-select v-model="form.plan" name="plan" label="name" placeholder="Select Plan" :options="loanplans" v-on:input="getSelectPlan"></v-select>
                            <has-error :form="form" field="plan_id"></has-error>
                            <input
                              type="hidden"
                              name="plan_id"
                              v-model="form.plan_id"
                            />
                          </div>
                          <div class="form-group">
                            <label
                              >Description<span class="red">*</span></label
                            >
                            <input
                              v-model="form.description"
                              type="text"
                              name="description"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('description'),
                              }"
                              placeholder="Enter Description"
                            />
                            <has-error
                              :form="form"
                              field="description"
                            ></has-error>
                          </div>
                          <div class="form-group" v-if="form.planType == 'individual'">
                            <label>Guarantor </label>
                            <v-select v-model="guarantor"  name="guarantor_id" label="name" :options="members" placeholder="Select Member" v-on:input="getLoanGuarantor">
                              
                            </v-select>
                            
                            <has-error
                              :form="form"
                              field="guarantor_id"
                            ></has-error>
                          </div>
                          <div class="form-group" v-if="planTypeApplied == 'active'">
                            <label
                              >Loan Amount Type <span class="red">*</span></label
                            >
                            <select
                              v-model="form.loanAmountType"
                              name="loanAmountType"
                               @change="changeLoanAmountType"
                              class="form-control"
                             
                              :class="{
                                'is-invalid': form.errors.has('loanAmountType'),
                              }"
                            >
                              <option value="">Select Loan Amount Type</option>
                              <option value="static">Static</option>
                              <option value="dynamic">Dynamic</option>
                            </select>
                            <has-error :form="form" field="loanAmountType"></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic'">
                            <label>Loan Amount <span class="red">*</span></label>
                            <input
                              v-model="form.loanAmount"
                              type="text"
                              name="loanAmount"
                              required
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('loanAmount'),
                              }"
                              placeholder="Enter Customer loanAmount"
                            />
                            <has-error
                              :form="form"
                              field="loanAmount"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic'">
                            <label>File Charge Amount <span class="red">*</span></label>
                            <input
                              v-model="form.fileCharge"
                              type="text"
                              name="fileCharge"
                              required
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('fileCharge'),
                              }"
                              placeholder="Enter Customer fileCharge"
                            />
                            <has-error
                              :form="form"
                              field="fileCharge"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic' && processingFeeType == 'fixed'">
                            <label>Processing Fee Amount <span class="red">*</span></label>
                            <input
                              v-model="form.processingFee"
                              type="text"
                              name="processingFee"
                              required
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('processingFee'),
                              }"
                              placeholder="Enter Customer processingFee"
                            />
                            <has-error
                              :form="form"
                              field="processingFee"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic' && processingFeeType == 'percent'">
                            <label>Processing Fee Amount %<span class="red">*</span></label>
                            <input
                              v-model="form.processingFee"
                              type="number"
                              step=".01"
                              name="processingFee"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('processingFeePer'),
                              }"
                              placeholder="Enter Customer processingFee"
                              readonly
                            />
                            <has-error
                              :form="form"
                              field="processingFee"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic' && insuranceFeeType == 'fixed'">
                            <label>Insurance Fee Amount <span class="red">*</span></label>
                            <input
                              v-model="form.insuranceFee"
                              type="text"
                              name="insuranceFee"
                              required
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('insuranceFee'),
                              }"
                              placeholder="Enter Customer insuranceFee"
                            />
                            <has-error
                              :form="form"
                              field="insuranceFee"
                            ></has-error>
                          </div>
                          <div class="form-group"  v-if="form.loanAmountType == 'dynamic' && insuranceFeeType == 'percent'">
                            <label>Insurance Fee Amount %<span class="red">*</span></label>
                            <input
                              v-model="form.insuranceFee"
                              type="number"
                              step=".01"
                              name="insuranceFee"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('insuranceFeePer'),
                              }"
                              placeholder="Enter Customer insuranceFee"
                              readonly
                            />
                            <has-error
                              :form="form"
                              field="insuranceFee"
                            ></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  CREATE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-success">
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="disbursmentModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Disbursement Loan</h4>
            </div>
            <form @submit.prevent="createDisbursement()">
              <div class="modal-body">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>
                              Disbursement Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.disbursementDate"
                              type="date"
                              name="disbursementDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'disbursementDate'
                                ),
                              }"
                              placeholder="Enter joining Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="disbursementDate"
                            ></has-error>
                            <input
                              type="hidden"
                              name="disbursement_id"
                              v-model="form.disbursement_id"
                            />
                          </div>

                          <div class="form-group">
                            <label
                              >EMI Start Date <span class="red">*</span></label
                            >
                            <input
                              v-model="form.emiStartDate"
                              type="date"
                              name="emiStartDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('emiStartDate'),
                              }"
                              placeholder="Enter joining Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="emiStartDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  DISBURSEMENT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.file-charge-modal -->
      <div class="modal fade" id="fileChargeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">File Charge</h4>
            </div>
            <form @submit.prevent.once="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect File Charge </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.processing-fee-modal -->
      <div class="modal fade" id="processingFeeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Processing Fee Charge</h4>
            </div>
            <form @submit.prevent.once="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect Processing Fee </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>

      <!-- /.insurance-fee-modal -->
      <div class="modal fade" id="insuranceFeeModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Insurance Fee Charge</h4>
            </div>
            <form @submit.prevent.once="fileChargeProcessingFeeCollect()">
              <div class="modal-body">
                <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Select Ledger Account </label>
                            <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                            >
                              <option v-if="!form.branch_ledger_id" selected value="">
                                Select Ledger Account
                              </option>
                              <option
                                :value="bank_account.id"
                                v-for="bank_account in bank_accounts"
                                :key="bank_account.id"
                              >
                                {{bank_account.name}} {{bank_account.remark}}
                              </option>
                            </select>
                            <has-error :form="form" field="branch_ledger_id"></has-error>
                          </div>
                          <div class="form-group">
                            <label>
                              Payment Date
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'paymentDate'
                                ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                            />
                            <has-error
                              :form="form"
                              field="paymentDate"
                            ></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label>Collect Insurance Fee </label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              disabled
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'amt'
                                ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success">
                  COLLECT
                </button>

                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      
      <!-- /.modal -->
      <div class="modal fade" id="viewPrintFullModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="print()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            
            <div class="modal-body" id="print">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <!-- <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br> -->
                      <table class="table table-condensed">
                        <thead>
                          <td width="18%"><img :src="logo" height="90"></td>
                          <td class="text-center" style="text-align:center;"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small></h4></td>
                          <td class="text-right" style="text-align:center;" width="20%"><barcode v-bind:value="seeRecord.member.code" height="45" width="1">
                              Show this if the rendering fails.
                            </barcode>
                          </td>
                        </thead>
                      </table>
                      <h1 class="text-center" style="text-align:center;">Loan Application Form</h1>
                      <div>
                      <table class="table table-condensed">
                        <thead>
                          <td colspan="2">Branch : {{seeRecord.branch.name}} ({{seeRecord.branch.branchCode}})</td>
                          
                          <td colspan="2" class="text-right">Date : {{seeRecord.created_at | myDate}}</td>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Customer Name </td><td> {{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td rowspan="6" colspan="2">
                              <div style="border-width:3px;border-style:solid;width:150px;height:180px;float:right;text-align:center;"><br>Customer Photo <br>with Cross Sign</div>
                            </td>
                            
                          </tr>
                          <tr>
                            <td>Contact No </td><td> {{seeRecord.member.mobile}}</td>
                          </tr>
                          <tr>
                            <td>DOB </td><td> {{memberDetail.dob | myDate}}</td>
                          </tr>
                          <tr>
                            <td>Gender </td><td> {{memberDetail.gender}}</td>
                          </tr>
                          <tr>
                            <td>Spouse Name  </td><td> {{memberDetail.spouseName}}</td>
                          </tr>
                          <tr>
                            <td>C/O </td><td> {{memberDetail.fatherName}}</td>
                          </tr>
                          <tr>
                            <td colspan="2"><strong>Address Details</strong></td>
                            <td colspan="2"></td>
                          </tr>
                          <tr>
                            <td>Address </td><td> {{memberDetail.address}}, {{memberDetail.area}}</td>
                            <td>District/State/Pincode </td><td v-if="memberDetail.state"> {{memberDetail.district}}, {{memberDetail.state.name}} - {{memberDetail.pin}}</td>
                          </tr>
                          <tr>
                            <td colspan="2"><strong>Income</strong></td>
                            <td colspan="2"><strong>Applied Loan Details</strong></td>
                          </tr>
                          <tr>
                            <td>Occupation </td><td> {{memberDetail.jobType}}</td>
                            <!-- <td>Plan Name </td><td> {{pl.name}} <span class="text-right"><strong v-if="pl.rateOfInterest > 0">Interest Rate  {{pl.interestRate}}</strong></span></td> -->
                            <td>Plan Name </td><td> {{pl.name}} <span class="text-right">Interest Rate  22.7</span></td>
                          </tr>
                          <tr>
                            <td>Business Address </td><td> {{memberDetail.businessAddress}}</td>
                            <td>Plan Type </td><td> {{pl.planType}}</td>
                          </tr>
                          <tr>
                            <td>Income (INR) </td><td> {{memberDetail.incomeAmount}}</td>
                            <td>GST Include </td><td> {{pl.includeGst}}</td>
                          </tr>
                          <tr>
                            <td>Income Type </td><td> {{memberDetail.incomeType}}</td>
                            <td>Amount to be Paid </td><td v-if="seeRecord.loanAmount"> {{seeRecord.loanAmount}}</td><td v-else> {{pl.amount}}</td>
                          </tr>
                          <tr>
                            <td>Business Name </td><td> {{memberDetail.businessName}}</td>
                            <td>File Charge </td><td> {{ fileChargeFee(seeRecord) }}</td>
                          </tr>
                          <tr>
                            <td>Minimum Income </td><td> {{memberDetail.minAmount}}</td>
                            <!-- <td>Processing Fee <span v-if="pl.planType === 'normal'">(%)</span> </td><td v-if="seeRecord.processingFee"> {{seeRecord.processingFee}}</td><td v-else> {{pl.processingFee}}</td> -->
                            <td>Processing Fee <span v-if="pl.planType === 'normal'">(%)</span> </td><td>{{ processingFee(seeRecord) }}</td>
                          </tr>
                          <tr>
                            <td>Maximum Income </td><td> {{memberDetail.maxAmount}}</td>
                            <td>Insurance Fee <span v-if="pl.planType === 'normal'">(%)</span> </td><td>{{ insuranceFee(seeRecord) }}</td>
                            
                          </tr>
                          <tr>
                            <td colspan="2"></td>
                            <td>Plan Amount </td>
                            <td>{{ planAmt(seeRecord) }}</td>
                          </tr>
                          <tr>
                            <td colspan="2"></td>
                            <td>No of Payments </td><td> {{pl.noOfPayments}}</td>
                          </tr>
                          <tr>
                            <td colspan="2"></td>
                            <td>Recovery type </td><td> {{pl.recoveryType}}</td>
                          </tr>
                          <tr>
                            <td colspan="3"><strong>Guarantor Details : </strong></td>
                            <td rowspan="3">
                              <div style="border-width:3px;border-style:solid;width:120px;height:140px;float:right;text-align:center;"><br><center>Guarantor Photo <br>with Cross Sign</center></div>
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Name : </strong> </td><td><span v-if="seeRecord.guarantor"> {{seeRecord.guarantor.name}} ( {{seeRecord.guarantor.code}} )</span></td>
                            <td><strong>Contact Number : </strong><span v-if="seeRecord.guarantor">{{seeRecord.guarantor.mobile}} </span></td>
                          </tr>
                          <tr>
                            <td><strong>Nominee Name : {{memberDetail.nomineeName}}</strong></td>
                            <td><strong>Nominee Mobile : </strong>{{memberDetail.nomineePhone}}</td>
                            <td><strong>Nominee Dob : </strong>{{memberDetail.nomineeDob}}</td>
                          </tr>
                        </tbody>
                      </table>
                      <br><br>
                      <p><table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      <br><br><br><br><br><br>
                      <p>1. उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता है जो स्पष्ट करता है कि सर्च की पालना नहीं की गई है तो कंपनी को अधिकार है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे</p>
                      <p>2. मैं /हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई आर दर्ज है।</p>
                      <p>3. यह है कि मैं / हमें किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी से मुझे / हमको डिफॉल्टर घोषित नहीं किया गया है।</p>
                      <p>4. यह है कि मैं हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं हम भुगतान करने में देरी नहीं करेंगे।</p>
                      <p>5. यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा मैं उसके साथ विनम्र व्यवहार रखूंगा  रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी कर्मचारी तथा कंपनी हमारे प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे</p>
                      
                      <p>6. यह है कि मैं हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना फोन इत्यादि करने के लिए कंपनी जिम्मेदार नहीं होगी इस बात की याददाश्त संबंधित संपूर्ण जिम्मेदारी मेरी या  हमारी होगी</p>
                      <p>7. यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में लिखित प्रदान करेंगे</p>
                      <p>8. यह है कि मैं /हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों को बैंक में स्टॉप नहीं कराएंगे और ना ही उक्त चेक के खोने की रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आएंगे यदि हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी !</p>
                      <p>9. यह है कि कंपनी द्वारा के संग्रहण संबंधित जो सुविधाएं जैसे कि s.m.s. कॉलिंग मेल किया नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज अलग से मांगेंगे वह हम प्रदान करेंगे|</p>
                      <p>10. यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व  है अगर भविष्य में आवेदक के साथ  कोई आकस्मिक घटना मृत्यु या दिवालिया या गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया जाएगा</p>
                      <p>11. यह है कि हम मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे विरोध कानूनी कार्रवाई करने का अधिकार रखेगी मैं हम ने लोन के बारे में समस्त जानकारी जैसे ब्याज कथा किस्तों की राशि किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं हम पूरी तरह तैयार है और अगर मैं हम किस्त देने में देरी करते हैं तो उस पर लगने वाला अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा | </p>
                      <p>12. यह है कि मैं हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है किस बात से हम पहले से जानकार हैं | </p>
                      <p>13. यह है कि हम मैं अपनी किस्तों का भुगतान साप्ताहिक रूप में करना चाहता हूं | </p>
                      <p>14. यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं हम समय पर उपस्थित हो जाएंगे | </p>
                      <p>15. यह है कि मेरी सालाना आय ₹500000 से कम है उक्त एग्रीमेंट या लोन को करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो हवास में यह एग्रीमेंट कर रहे हैं | </p>

                      <br>
                      <p><table class="table">
                          <thead>
                            <th>Member Signature <br>(सदस्या के हस्ताक्षर)</th>
                            <th>Guarantor Signature <br>(जमानतदार के हस्ताक्षर)</th>
                            <th>Branch Seal With Signature <br>(शाखा मोहर के साथ हस्ताक्षर)</th>
                          </thead>
                        </table>
                      </p>
                      <br><br><br><br><br><br><br><br><br><br>

                      </div>
                      <div v-if="seeRecord.status == 'pending'">
                        <br><br>
                        <table class="table">
                          <thead>
                            <th>Application Date</th>
                            <th>Customer</th>
                            <th>Account Number</th>
                            <th>Guarantor Name</th>
                            <th>Plan Amount</th>
                            <th>Paid Amount</th>
                            <th v-show="pl.planType === 'normal'">No. of EMI</th>
                          </thead>
                          <tbody>
                            <td>{{seeRecord.disbursementDate | myDate}}</td>
                            <td>{{seeRecord.member.name}} ({{seeRecord.member.code}})</td>
                            <td>{{memberDetail.accountNumber}}</td>
                            <td>{{memberDetail.guarantorName}}</td>
                            <td v-if="pl.planType === 'normalReduced' || pl.planType === 'special'">{{ showPlanAmtReduced(pl) }}</td>
                            <td v-else>{{ showPlanAmtNormal(pl) }}</td>
                            <td>{{pl.amount}}</td>
                            <td v-show="pl.planType === 'normal'">{{pl.noOfPayments}}</td>
                          </tbody>
                        </table>
                        <br><br>
                        <table class="table" v-if="seeRecord.status == 'pending'">
                          <thead>
                            <th>Branch Manager Signature</th>
                            <th>Customer Signature</th>
                            <th>Date</th>
                          </thead>
                        </table>
                        <br><br>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      
      <view-loan-plan :seeRecord="this.seeRecord" :pl="this.pl" :memberDetail="this.memberDetail" :getCompanyRecord="this.getCompanyRecord" :logo="this.logo"></view-loan-plan>
      <!-- /.modal -->
      <div class="modal fade" id="viewModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Loan Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Branch Name</b>

                          <a class="pull-right">{{ seeRecord.branch.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Branch Code</b>
                          <a class="pull-right">{{
                            seeRecord.branch.branchCode
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Name</b>
                          <a class="pull-right">{{ seeRecord.agent.name }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Agent Code</b>
                          <a class="pull-right">{{ seeRecord.agent.code }}</a>
                        </li>

                        <li class="list-group-item">
                          <b>Plan Details</b>
                          <table
                            class="table table-sm table-striped table-dark"
                          >
                            <tr>
                              <td><b>Plan Name </b> : {{ pl.name }}</td>
                              <td><b>Plan Type </b> : {{ pl.planType }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Type of Interest</b> : {{ pl.typeOfInterest }}
                              </td>
                              <td>
                                <!-- <b>Tenure </b>: Year - {{ pl.tenureYear }},
                                Month - {{ pl.tenureMonth }}, Day -
                                {{ pl.tenureDay }} -->
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>Recovery Type</b> : {{ pl.recoveryType }}
                              </td>
                              <td>
                                <b>Number of Payments</b> :
                                {{ pl.noOfPayments }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Amount</b> : {{ pl.amount }}</td>
                              <td>
                                <b>Advance Installment</b> :
                                {{ pl.acvanceInstallment }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>Panulty </b>: {{ pl.panulty }}</td>
                              <td>
                                <b>Processing Fee </b>: {{ pl.processingFee }}
                              </td>
                            </tr>
                            <tr>
                              <td><b>File Charge</b> : {{ pl.fileCharge }}</td>
                              <td v-if="pl.created_by">
                                <b>Created By</b> : {{ pl.created_by.name }}
                              </td>
                            </tr>
                          </table>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.member_id">
                          <b>Member Name</b>
                          <a class="pull-right">{{ seeRecord.member.name }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
                <div class="col-md-6">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul
                        class="list-group list-group-unbordered mb-3"
                        v-if="seeRecord.branch"
                      >
                        <li class="list-group-item">
                          <b>Plan Type</b>
                          <a class="pull-right">{{ seeRecord.planType }}</a>
                        </li>

                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Name</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.name
                          }}</a>
                        </li>
                        <li class="list-group-item" v-if="seeRecord.collection_center">
                          <b>Group Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center.centerCode
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.name
                          }}</a>
                        </li>
                        <li
                          class="list-group-item"
                          v-if="seeRecord.collection_center_leader"
                        >
                          <b>Group Leader Code</b>
                          <a class="pull-right">{{
                            seeRecord.collection_center_leader.code
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Disbursement Date</b>
                          <a class="pull-right">{{
                            seeRecord.disbursementDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>EMI Start Date</b>
                          <a class="pull-right">{{
                            seeRecord.emiStartDate
                          }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Payment Mode</b>
                          <a class="pull-right">{{ seeRecord.paymentMode }}</a>
                        </li>
                        <li class="list-group-item">
                          <b>Status</b>
                          <a class="pull-right">{{ seeRecord.status }}</a>
                        </li>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-primary"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <div class="modal fade" id="viewGroupMember">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Member Details</h4>
            </div>
            <div class="modal-body">
              <!-- right column -->
              <div class="row">
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <ul class="list-group list-group-unbordered mb-3">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>C/O</th>
                              <th>Address</th>
                              <th>City</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="groupmem">
                              <td>
                                {{ groupmem.fatherName }}
                              </td>
                              <td>
                                {{ groupmem.address}}
                              </td>
                              <td>
                                {{groupmem.city}}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ul>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
            </div>
            <div class="modal-footer text-center">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      <!-- Demand Probeshnary note  -->
      <demandprobeshnarynote :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo" :pl="pl" :mem="mem"></demandprobeshnarynote>
      <!-- /.modal -->
      <!-- Aadhar Agreement Letter  -->
      <aadharagreementletter :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :logo="logo" :pl="pl" :mem="mem"></aadharagreementletter>
      <!-- /.modal -->
      <!-- Previous Loan Record  -->
      <previousloanrecord :seeRecord="seeRecord" :getCompanyRecord="getCompanyRecord" :memberloanplans="memberloanplans" :logo="logo"></previousloanrecord>
      <!-- /.modal -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import { Printd } from 'printd'
import settingrecord from '../../mixins/SettingRecords'
import demandprobeshnarynote from '../components/DemandProbeshnaryNote.vue'
import aadharagreementletter from '../components/AdharAgreementLetter.vue'
import previousloanrecord from '../components/PreviousLoanRecord.vue'
import GetBranch from '../../mixins/BranchRecords'
import getPreviousLoan from '../../mixins/PreviousLoanRecord'
import VueBarcode from 'vue-barcode'
import VueLoanPlan from './ViewLoan.vue'
export default {
  name: 'my-component',
  mixins: [GetBranch, settingrecord, getPreviousLoan],
  data () {
    return {
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      @page {
        size: A4;
        margin: 0;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      p {font-size:12px;}
      table, th, td { border:1px solid #000;font-size:12px; padding:0.4em; border-collapse: collapse; }`,
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      userType: '',
      per_page: 10,
      table_search: '',
      processing: false,
      totalAmt: 0,
      user: {},
      staffs: [],
      staf: {},
      editMode: false,
      planTypeApplied: 'inActive',
      logo: '',
      mem: {},
      guarantor: {},
      groupmem: {},
      memberDetail: {},
      collectionCenters: {},
      colC: {},
      branches: [],
      branch: {},
      members: [],
      bank_accounts: [],
      pl: {},
      processingFeeType: '',
      insuranceFeeType: '',
      seeRecord: {},
      loanplans: [],
      purposes: [],
      groupMembers: {},
      getCompanyRecord: {},
      viewCollectionCenter: '',
      getSettingRecord: '',
      userStatus: '',
      memberloanplans: [],
      form: new Form({
        id: '',
        collection_center_id: '',
        member_id: '',
        guarantor_id: null,
        branch_id: '',
        agent_id: null,
        center_leader_id: '',
        plan_id: '',
        plan: {},
        purpose: {},
        purpose_id: '',
        description: '',
        planType: 'individual',
        status: '',
        branch_ledger_id: '',
        disbursement_id: '',
        disbursementDate: new Date().toISOString().slice(0, 10),
        emiStartDate: '',
        amt: '',
        loanAmount: null,
        processingFee: null,
        insuranceFee: null,
        fileCharge: null,
        type: '',
        loanAmountType: '',
        paymentDate: null
      }),
      // columns: [
      //   {
      //     label: 'PLAN Name',
      //     field: 'plan_name'
      //   },
      //   {
      //     label: 'PAY AMOUNT',
      //     field: 'plan_amt'
      //   },
      //   {
      //     label: 'MEMBER',
      //     field: 'member_name'
      //   },
      //   {
      //     label: 'AGENT',
      //     field: 'agent.name'
      //   },
      //   {
      //     label: 'BRANCH NAME',
      //     field: 'branch.name'
      //   },
      //   {
      //     label: 'BRANCH CODE',
      //     field: 'branch.branchCode'
      //   },
      //   {
      //     label: 'STATUS',
      //     field: 'Status'
      //   },
      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: []
    }
  },
  components: {
    'barcode': VueBarcode,
    'view-loan-plan': VueLoanPlan,
    demandprobeshnarynote,
    aadharagreementletter,
    previousloanrecord
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    getSelectPurpose () {
      this.form.purpose_id = ''
      this.form.purpose_id = this.form.purpose.id
    },
    newModalLoan () {
      var c = JSON.parse(localStorage.user)
      this.userType = c.type
      this.form.branch_id = null
      this.user = this.$store.state.user
      this.editMode = false
      this.form.loanAmountType = ''
      this.planTypeApplied = 'inActive'
      this.members = []
      this.guarantor = {}
      this.staffs = []
      this.staf = {}
      this.collectionCenters = []
      this.mem = {}
      this.guarantor = {}
      this.form.reset()
      if (c.type === 'staff') {
        this.form.branch_id = c.agent_profile.branch_id
        this.getMemberAndGroupAndAgent()
      }
      $('#newModalLoan').modal({backdrop: 'static', keyboard: false})
      // let loader = this.$loading.show()
    },
    changeLoanAmountType () {
      if (this.form.loanAmountType === 'static') {
        this.form.loanAmount = null
        this.form.fileCharge = null
        this.form.processingFee = null
        this.form.insuranceFee = null
      } else if (this.form.loanAmountType === 'dynamic') {
        this.form.loanAmount = this.form.plan.amount
        this.form.fileCharge = this.form.plan.fileCharge
        this.form.processingFee = this.form.plan.processingFee
        this.form.insuranceFee = this.form.plan.insuranceFee
      }
    },
    getBranchRecord (branch) {
      this.form.branch_id = ''
      if (branch) {
        this.form.branch_id = branch.id
      }
      this.changeFilter()
    },
    planName (plan) {
      var pln = JSON.parse(plan)
      return pln.name
    },
    // planAmt (plan) {
    //   var pln = JSON.parse(plan)
    //   return pln.amount
    // },
    planAmt (row) {
      var fpi = 0
      var gstAmt = 0
      var pln = JSON.parse(row.plan)
      if (pln.planType !== 'normal') {
        if (pln.fileChargeIncludeAmt === 'true') {
          fpi += row.fileCharge ? row.fileCharge : parseInt(pln.fileCharge)
        }
        if (pln.processingFeeIncludeAmt === 'true') {
          fpi += row.processingFee ? row.processingFee : parseInt(pln.processingFee)
        }
        if (pln.insuranceFeeIncludeAmt === 'true') {
          fpi += row.insuranceFee ? row.insuranceFee : parseInt(pln.insuranceFee)
        }
        if (pln.includeGst === 'true') {
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        return row.loanAmount ? row.loanAmount + fpi : pln.amount + fpi
      } else {
        return row.loanAmount ? row.loanAmount : pln.amount
      }
    },
    viewPrintModal (row) {
      this.seeRecord = {}
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberDetail = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewPrintFullModal (row) {
      this.form.reset()
      this.loadCompanyProfile()
      $('#viewPrintFullModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberDetail = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteDisbursment (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('disbursement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    viewModal (row) {
      this.form.reset()
      $('#viewModal').modal({backdrop: 'static', keyboard: false})
      this.seeRecord = row
      this.pl = JSON.parse(row.plan)
    },
    viewMemberAddDetail (id) {
      this.groupmem = {}
      this.$axios
        .get('member?all=all&user_id=' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.groupmem = data.data[0]
        })
        .catch(function (error) { console.log(error) })
      $('#viewGroupMember').modal({backdrop: 'static', keyboard: false})
      // this.viewCollectionCenter = collection_center.id
      // console.log(collection_center.id)
    },
    viewPrintDimandProbeshnoryNote (row) {
      this.seeRecord = row
      this.loadCompanyProfile()
      $('#viewPrintDimandProbeshnoryNote').modal({backdrop: 'static', keyboard: false})
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewPrintAadharAgreementLetter (row) {
      this.seeRecord = row
      this.loadCompanyProfile()
      $('#viewPrintAadharAgreementLetter').modal({backdrop: 'static', keyboard: false})
      this.pl = JSON.parse(row.plan)
      this.$axios
        .get('member?all=all&user_id=' + row.member_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.mem = data.data[0]
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewPreviousLoanRecords (row) {
      this.seeRecord = row
      this.loadCompanyProfile()
      this.getPreviousLoanRecord(row.member_id)
      $('#viewPreviousLoanRecord').modal({backdrop: 'static', keyboard: false})
    },
    getBranchAgent () {
      this.form.agent_id = this.staf.user_id
    },
    getBranchMember () {
      this.form.member_id = this.mem.user_id
    },
    getLoanGuarantor () {
      this.form.guarantor_id = this.guarantor.user_id
    },
    getBranchCollectionCenter () {
      this.form.collection_center_id = this.colC.id
      this.loadGroupMember(this.form.collection_center_id)
    },
    // processingFeeCollect () {
    //   if (this.form.planType === 'individual') {
    //     this.$delete(this.form, 'collection_center_id')
    //     this.$delete(this.form, 'center_leader_id')
    //   }
    //   this.$axios
    //     .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then(() => {
    //       Fire.$emit('AfterCreate')
    //       $('#processingFeeModal').modal('hide')
    //       Toast.fire({
    //         icon: 'success',
    //         title: 'Processing Fee Paid Successfully'
    //       })
    //     })
    // },

    createLoan () {
      if (this.processing === true) {
        return false
      }
      this.processing = true
      this.form.planType = 'individual'
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
        this.$delete(this.form, 'center_leader_id')
      }
      this.$axios
        .post('createloan', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.reset()
          Fire.$emit('AfterCreate')
          $('#newModalLoan').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Create New Loan Successfully'
          })
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      setTimeout(() => {
        this.processing = false
      }, 3000)
    },
    disbursmentModal (row) {
      this.form.reset()
      $('#disbursmentModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    fileChargeModal (row) {
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#fileChargeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'fileCharge'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.includeGst === 'true') {
        this.form.amt = row.fileCharge ? row.fileCharge + (row.fileCharge * 18 / 100) : this.pl.fileCharge + (this.pl.fileCharge * 18 / 100)
      } else {
        this.form.amt = row.fileCharge ? row.fileCharge : this.pl.fileCharge
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    processingFeeModal (row) {
      var pfamt = 0
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#processingFeeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'processingFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.processingFeeType === 'percent') {
        pfamt = row.loanAmount ? (this.pl.processingFee * row.loanAmount / 100) : (this.pl.processingFee * this.pl.amount / 100)
        if (this.pl.includeGst === 'true') {
          this.form.amt = pfamt + pfamt * 18 / 100
        } else {
          this.form.amt = pfamt
        }
      }
      if (this.pl.processingFeeType === 'fixed') {
        pfamt = row.processingFee ? row.processingFee : this.pl.processingFee
        if (this.pl.includeGst === 'true') {
          this.form.amt = pfamt + pfamt * 18 / 100
        } else {
          this.form.amt = pfamt
        }
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    insuranceFeeModal (row) {
      var ifamt = 0
      this.form.reset()
      this.pl = {}
      this.pl = JSON.parse(row.plan)
      $('#insuranceFeeModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      this.form.type = 'insuranceFee'
      this.form.paymentDate = new Date().toISOString().slice(0, 10)
      if (this.pl.insuranceFeeType === 'percent') {
        ifamt = row.loanAmount ? (this.pl.insuranceFee * row.loanAmount / 100) : (this.pl.insuranceFee * this.pl.amount / 100)
        if (this.pl.includeGst === 'true') {
          this.form.amt = ifamt + ifamt * 18 / 100
        } else {
          this.form.amt = ifamt
        }
      }
      if (this.pl.insuranceFeeType === 'fixed') {
        ifamt = row.insuranceFee ? row.insuranceFee : this.pl.insuranceFee
        if (this.pl.includeGst === 'true') {
          this.form.amt = ifamt + ifamt * 18 / 100
        } else {
          this.form.amt = ifamt
        }
      }
      // this.form.plan = JSON.parse(row.plan)
      this.form.disbursement_id = row.id
      this.getBranchBankAccount(row.branch_id)
    },
    fileChargeFee (row) {
      var fcamt
      var pln = JSON.parse(row.plan)
      fcamt = row.fileCharge ? row.fileCharge : pln.fileCharge
      if (pln.includeGst === 'true') {
        return fcamt + fcamt * 18 / 100
      } else {
        return fcamt
      }
    },
    processingFee (row) {
      var pfamt
      var pln = JSON.parse(row.plan)
      if (pln.processingFeeType === 'percent') {
        pfamt = row.loanAmount ? (pln.processingFee * row.loanAmount / 100) : (pln.processingFee * pln.amount / 100)
        if (pln.includeGst === 'true') {
          return pfamt + pfamt * 18 / 100
        } else {
          return pfamt
        }
      }
      if (pln.processingFeeType === 'fixed') {
        pfamt = row.processingFee ? row.processingFee : pln.processingFee
        if (pln.includeGst === 'true') {
          return pfamt + pfamt * 18 / 100
        } else {
          return pfamt
        }
      }
    },
    insuranceFee (row) {
      var ifamt
      var pln = JSON.parse(row.plan)
      if (pln.insuranceFeeType === 'percent') {
        ifamt = row.loanAmount ? (pln.insuranceFee * row.loanAmount / 100) : (pln.insuranceFee * pln.amount / 100)
        if (pln.includeGst === 'true') {
          return ifamt + ifamt * 18 / 100
        } else {
          return ifamt
        }
      }
      if (pln.insuranceFeeType === 'fixed') {
        ifamt = row.insuranceFee ? row.insuranceFee : pln.insuranceFee
        if (pln.includeGst === 'true') {
          return ifamt + ifamt * 18 / 100
        } else {
          return ifamt
        }
      }
    },
    // file charge and processing fee and insurance fee collection
    fileChargeProcessingFeeCollect () {
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
        this.$delete(this.form, 'center_leader_id')
      }
      this.$axios
        .post('membercollection', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.disbursementStartDate = ''
          this.form.disbursementEndDate = ''
          this.form.startEmiEndDate = ''
          this.form.endEmiEndDate = ''
          this.form.branch_id = ''
          this.changeFilter()
          if (this.form.type === 'fileCharge') {
            $('#fileChargeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'File Charge Paid Successfully'
            })
          }
          if (this.form.type === 'processingFee') {
            Fire.$emit('AfterCreate')
            $('#processingFeeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Processing Fee Paid Successfully'
            })
          }
          if (this.form.type === 'insuranceFee') {
            Fire.$emit('AfterCreate')
            $('#insuranceFeeModal').modal('hide')
            Toast.fire({
              icon: 'success',
              title: 'Insurance Fee Paid Successfully'
            })
          }
        }).catch(function (error) {
          if (error.response.data.error) {
            var result = []
            var er = error.response.data.error
            for (var l in er) {
              if (er.hasOwnProperty(l)) {
                result.push(l + ': ' + er[l])
              }
            }
            // Toast.fire({ icon: 'error', title: result.join('\n') })
            Swal.fire('Failed!', result.join('\n').toUpperCase(), 'error')
          }
          if (error.response.data.message) {
            let er = error.response.data.message
            Toast.fire({ icon: 'error', title: er })
          }
        })
    },
    getBranchBankAccount (id) {
      this.$axios
        .get('branchledger?all=all&status=active&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.bank_accounts = data.data
          $.each(this.bank_accounts, function (key, value) {
            this.bank_accounts[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
    },
    createDisbursement () {
      if (this.processing === true) {
        return false
      }
      this.processing = true
      if (this.form.planType === 'group') {
        this.$delete(this.form, 'member_id')
      }
      if (this.form.planType === 'individual') {
        this.$delete(this.form, 'collection_center_id')
        this.$delete(this.form, 'center_leader_id')
      }
      // if (this.form.paymentMode === 'cash') {
      //   this.$delete(this.form, 'bank_id')
      //   this.$delete(this.form, 'bank_account_id')
      // }
      this.$axios
        .post('disbursement', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.reset()
          Fire.$emit('AfterCreate')
          $('#disbursmentModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'New Loan Disbursed Successfully'
          })
        })
        .catch(function (error) {
          Swal.fire('Failed!', error.response.data.error, 'error')
          this.form.errors.errors = error.response.data.error
          // console.log(error.response.data.error)
        }.bind(this)
        )
      setTimeout(() => {
        this.processing = false
      }, 3000)
    },
    editModal (row) {
      // console.log(row)
      this.editMode = true
      this.form.reset()
      this.form.fill(row)
      if (this.form.loanAmount != null) {
        this.form.loanAmountType = 'dynamic'
      } else {
        this.form.loanAmountType = 'static'
      }
      // this.form.plan = JSON.parse(row.plan)
      this.getMemberAndGroupAndAgent()
      $('#newModalLoan').modal({backdrop: 'static', keyboard: false})
      if (row.planType === 'group') {
        this.loadGroupMember(this.form.collection_center_id)
      }
      this.form.plan = _.find(this.loanplans, function (o) {
        return o.id === row.plan_id
      })
      // console.log(this.form.plan)
    },

    updateLoan () {
      // console.log('update data')
      if (this.form.planType === 'group') {
        this.$delete(this.form, 'member_id')
      }
      if (this.form.planType === 'individual') {
        // alert('hello')
        this.$delete(this.form, 'center_leader_id')
        this.$delete(this.form, 'collection_center_id')
      }
      this.$axios
        .put('disbursement/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          this.form.reset()
          Fire.$emit('AfterCreate')
          $('#newModalLoan').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Loan Details Updated Successfully'
          })
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this.$axios
            .delete('collectioncentermember/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Fire.$emit('AfterCreate')

              Swal.fire('Deleted!', 'Your file has been deleted.', 'success')
            })
            .catch(() => {
              Swal.fire('Failed!', 'There was something wrong.', 'error')
            })
        }
      })
    },
    getSelectPlan () {
      // alert(this.form.plan.id)
      this.form.plan_id = this.form.plan.id
      this.form.loanAmount = this.form.plan.amount
      this.form.fileCharge = this.form.plan.fileCharge
      this.form.processingFee = this.form.plan.processingFee
      this.processingFeeType = this.form.plan.processingFeeType
      this.insuranceFeeType = this.form.plan.insuranceFeeType
      if (this.form.plan.planType === 'normal' || this.form.plan.planType === 'normalReduced' || this.form.plan.planType === 'interest') {
        this.planTypeApplied = 'active'
      } else {
        this.planTypeApplied = 'inActive'
        this.form.loanAmountType = 'static'
      }
    },
    getPlanType () {
      this.form.center_leader_id = null
      this.form.collection_center_id = null
      this.form.member_id = null
    },
    getGroupLeader () {
      // var x = this.groupMembers
    },
    getMemberAndGroupAndAgent () {
      var c = JSON.parse(localStorage.user)
      this.userStatus = ''
      if (c.type === 'staff') {
        if (c.role.name === 'Manager') {
          this.loadStaff()
        } else {
          this.staf = this.user.agent_profile
          this.staf.name = this.user.name + ' (' + this.user.code + ')'
          this.form.agent_id = this.staf.user_id
        }
      } else {
        this.loadStaff()
      }
      if (this.getSettingRecord === 'true') {
        this.userStatus = 'status=verified'
      }
      this.$axios
        .get('member?all=all&' + this.userStatus + '&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.member_id === item.user.id) {
              this.mem = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )

      // this.$axios
      //   .get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      //   .then((response) => response.data)
      //   .then((data) => {
      //     this.collectionCenters = data.data
      //     _.forEach(this.collectionCenters, function (item, key) {
      //       this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
      //     }.bind(this))
      //   })
      //   .catch(
      //     function (error) {
      //       Toast.fire({ icon: 'error', title: 'Please Try Again' })
      //       this.form.errors.errors = error.response.data.error
      //     }.bind(this)
      //   )
      // this.loadStaff()
    },
    loadStaff () {
      this.$axios
        .get('staff?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
            if (this.form.agent_id === item.user.id) {
              this.staf = item
            }
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadLoan () {
      this.$axios
        .get('loanplan?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.loanplans = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showPlanAmtNormal (pl) {
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.amount * pl.processingFee) / 100
      return pl.amount
    },
    showPlanAmtReduced (pl) {
      // return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'false') {
        return parseInt(pl.amount)
      } else if (pl.fileChargeIncludeAmt === 'false' && pl.processingFeeIncludeAmt === 'true') {
        return parseInt(pl.amount) + parseInt(pl.processingFee)
      } else if (pl.fileChargeIncludeAmt === 'true' && pl.processingFeeIncludeAmt === 'false') {
        return parseInt(pl.amount) + parseInt(pl.fileCharge)
      } else {
        return parseInt(pl.amount) + parseInt(pl.fileCharge) + parseInt(pl.processingFee)
      }
    },
    loadPurpose () {
      this.$axios
        .get('purpose?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.purposes = data.data
          $.each(this.purposes, function (key, value) {
            this.purposes[key].name = value.purpose
          }.bind(this))
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadCompanyProfile () {
      let loader = this.$loading.show()
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.getCompanyRecord = data
          if (this.getCompanyRecord.logo != null) {
            this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getCompanyRecord.logo
          } else {
            alert('hello')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    print () {
      const d = new Printd()
      d.print(document.getElementById('print'), [this.cssText])
      // Get HTML to print from element
      // const prtHtml = document.getElementById('print').innerHTML

      // Get all stylesheets HTML
      // let stylesHtml = ''
      // for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      //   stylesHtml += node.outerHTML
      // }
      // Open the print window
      // const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      // WinPrint.document.write(`<!DOCTYPE html>
      //   <html>
      //     <head>
      //       <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
      //         ${stylesHtml}
      //         <style type="text/css">
      //           table th, table td { border:1px solid #000; padding:0.5em; }
      //         </style>
      //     </head>
      //     <body>
      //         ${prtHtml}
      //     </body>
      //   </html>`)

      // WinPrint.document.close()
      // WinPrint.focus()
      // WinPrint.print()
      // WinPrint.close()
    },
    planRecoveryType (plan) {
      var pln = JSON.parse(plan)
      return pln.recoveryType
    },
    changeFilter (page = null, pg = null) {
      let loader = this.$loading.show()
      // var c = JSON.parse(localStorage.user)
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'disbursement'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      // if (c.type !== 'admin') {
      //   if (c.role.name === 'Manager') {
      //     pageUrl += `&branch_id=${c.agent_profile.branch_id}`
      //   } else {
      //     pageUrl += `&agent_id=${c.id}`
      //   }
      // }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      if (this.form.branch_id) {
        pageUrl += `&branch_id=${this.form.branch_id}`
      }
      this.$axios
        .get(`${pageUrl}&status=pending&searchTerm=individual`, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          // console.log(data)
          loader.hide()
          this.rows = data.data.data
          this.pagination = data.data
        }).catch(function (error) { console.log(error) })
    }
    // loadData () {
    //   let loader = this.$loading.show()
    //   console.log('hello load')
    //   this.$axios
    //     .get('disbursement?all=all&status=pending&searchTerm=individual', {headers: { Authorization: 'Bearer ' + localStorage.token }})
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //       _.forEach(this.rows, function (row, key) {
    //         this.totalAmt += parseInt(JSON.parse(row.plan).amount)
    //       }.bind(this))
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // }
  },

  created () {
    // this.loadMember()
    this.loadSettings()
    this.changeFilter()
    this.getBranch()
    // var c = JSON.parse(localStorage.user)
    // if (c.type === 'admin') {
    //   this.getBranch()
    // }
    this.loadLoan()
    this.loadPurpose()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
  @media print {
      .modal {
          position: absolute;
          left: 0;
          top: 0;
          margin: 0;
          padding: 0;
          overflow: visible!important;
      }
  }
  .table-responsive {
    overflow-y: visible !important;
  }
  .content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 3px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// IndividualLoan.vue?e96f2736